import { useEffect } from 'react';
import { GOOGLE_MAPS_CALLBACK_NAME } from 'constants/googlemaps';

const useGoogleMaps = () => {
    useEffect(() => {
        const apiKey = import.meta.env.VITE_DASHBOARD_GOOGLE_MAPS_API_KEY;
        const src = `https://maps.googleapis.com/maps/api/js?loading=async&key=${apiKey}&libraries=places&callback=${GOOGLE_MAPS_CALLBACK_NAME}`;
        const id = 'GOOGLE_MAPS_JS_API_SCRIPT';

        if (!apiKey || document.getElementById(id)) return;

        const script = Object.assign(document.createElement('script'), {
            id,
            src,
            async: true,
            defer: true,
        });

        document.head.appendChild(script);
    }, []);

    return window.google;
};

export { useGoogleMaps, GOOGLE_MAPS_CALLBACK_NAME };
